import { render, staticRenderFns } from "./UserRoleTable.vue?vue&type=template&id=21168f83&scoped=true"
import script from "./UserRoleTable.vue?vue&type=script&lang=js"
export * from "./UserRoleTable.vue?vue&type=script&lang=js"
import style0 from "./UserRoleTable.vue?vue&type=style&index=0&id=21168f83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21168f83",
  null
  
)

export default component.exports